import { Just, Maybe, Nothing } from "@omni/utils/maybe.utils";

import { CartModel } from "./@types/cart.model";

const requiredProps = [
    "baseStore",
    "billingAddressId",
    "deliveryAddressId",
    "callToActions",
    "cartsMerged",
    "checkoutStep",
    "customerId",
    "items",
    "messages",
    "storeId",
    "subTotal",
    "totalPrice"
];

export const returnMaybeCartModel = (data?: any): Maybe<CartModel> => {
    if (!data) {
        return Nothing();
    }

    try {
        return requiredProps.every((p) => p in data)
            ? Just<CartModel>(data)
            : Nothing();
    } catch {
        return Nothing();
    }
};
